module.exports = __webpack_public_path__ + "img/decline.a8c19e00.svg";